import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Button from '@hapana/shared/web/components/shared/button/button.component.jsx'

import AccessDenied from '../../pages/access-denied/access-denied.component.jsx'
import { ROUTES } from '../../app.constants'
import { usePermissions } from '../../stores/permissions.store'

const CONTROLS_PERMISSIONS = ['read_controls', 'write_controls']

const withAccessControl = (Component, { permissions } = {}) => {
  const requiredPermissions = permissions ?? CONTROLS_PERMISSIONS
  const isControlsGate = !permissions

  const WithAccessControl = (props) => {
    const { hasPermission, isLoading } = usePermissions()
    const navigate = useNavigate()
    const { t } = useTranslation('core')

    if (!isControlsGate && isLoading) {
      return null
    }

    if (!requiredPermissions.some((permission) => hasPermission(permission))) {
      return isControlsGate ? (
        <AccessDenied>
          <Button
            label={t('accessDenied.buttonControlLabel')}
            onClick={() => navigate(ROUTES.controlCenter.path)}
            data-testid="with-access-control-hoc-button-control-label"
          />
        </AccessDenied>
      ) : (
        <AccessDenied />
      )
    }

    return <Component {...props} />
  }

  WithAccessControl.displayName = `WithAccessControl(${Component.displayName || Component.name || 'Component'})`

  return WithAccessControl
}

export default withAccessControl
